import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { Categories, Items } from 'tilby-models';
import { TilbyItemElementComponent } from "@tilby/tilby-ui-lib/components/tilby-item-element";
import { ConfigurationManagerService } from 'src/app/core';
import { keyBy } from 'src/app/shared/utils';
import { ShowcaseListItemV2Component } from '../showcase-list-item-v2/showcase-list-item-v2.component';

@Component({
  selector: 'app-cashregister-search-items',
  templateUrl: './cashregister-search-items.component.html',
  styleUrls: ['./cashregister-search-items.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatListModule,
    ScrollingModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    TilbyItemElementComponent,
    ShowcaseListItemV2Component
  ]
})
export class CashregisterSearchItemsComponent implements OnInit {

    protected readonly configurationManagerService = inject(ConfigurationManagerService);
    protected readonly newUi = signal(this.configurationManagerService.isModuleAngular('cashregister.ui'));
    protected categoriesById: Record<string, Categories> = {};
    protected screenHeight = screen.height;

    @Input() getItemStockStatus : Function = () => {};
    @Output() showItem = new EventEmitter<Items>();
    @Output() addItemToSale = new EventEmitter<Items>();
    @Input() priceList : string = 'price1';
    @Output() searchItems = new EventEmitter<{ forceSearch: boolean, allCategories: boolean, categoryFilter?: string | number, typeFilter?: string, stockFilter?: string }>();
    @Input() showUnavailableStock: boolean = true;
    @Input() showThumbnail: boolean = true;
    @Input() truncatePriceWithDots: boolean = true;
    @Input() showUnavailable: boolean = true;
    @Input() visibleCategories : Categories[] = [];
    @Input() selectedCategory : Categories | undefined;

    @Input() isLoading : boolean = false;
    @Input() firstCategoryBorderRounded: boolean = false;
    @Input() showPrices: boolean = true;
    @Input() fontNameSize = 12;
    @Input() fontPriceSize = 12;
    @Input() showItemIcon = false;

    categoryFilter : number | string | undefined = "ALL" ;
    typeFilter : string | undefined = this.configurationManagerService.getPreference("cashregister.items_search_defaults.fields") || "ALL";
    stockFilter : string | undefined = this.configurationManagerService.getPreference("cashregister.items_search_defaults.stock") || "ALL";

    @Input() searchResults: {hasResults: boolean, allCategories: boolean | undefined, results: {id: string, name: string, items: Items[]}[]} = {
        "allCategories": false,
        "hasResults": false,
        "results": []
    };

    ngOnInit(): void {
        this.categoriesById = keyBy(this.visibleCategories, (c) => c.id);
        this.categoryFilter = this.selectedCategory?.id || "ALL" ;
        this.stockFilter = this.showUnavailable ? "ALL" : "ONLY_STOCK";

        this.typeFilter = this.configurationManagerService.getPreference("cashregister.items_search_defaults.fields") || "ALL";
        this.stockFilter = this.configurationManagerService.getPreference("cashregister.items_search_defaults.stock") || this.stockFilter;

        this.searchItems.emit({ forceSearch: true, allCategories: true, categoryFilter: this.categoryFilter, typeFilter: this.typeFilter, stockFilter: this.stockFilter });
    }

    onTypeChange(typeFilter: any){
      this.configurationManagerService.setUserPreference("cashregister.items_search_defaults.fields", typeFilter.value);
    }

    onStockChange(stockFilter: any) {
      this.configurationManagerService.setUserPreference("cashregister.items_search_defaults.stock", stockFilter.value);
    }

    trackByFunction(index: number, item: Items): number {
        return item.id!;
    }
}
